module.exports = __webpack_public_path__ + "static/img/tianfangyuansucai3.41191d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tianfangyuansucai3.png
// module id = 9PgA
// module chunks = 52